// TODO rename file to jsx file and move into components->globalComponents
import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import App from './App';
import Login from './pages/Login';
import Error from './pages/Error';
import NotFound from './pages/NotFound';
import Access from './pages/Access';

class AppWrapper extends Component {
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { location } = this.props;
    switch (location.pathname) {
      case '/login':
        return <Route path="/login" component={Login} />;
      case '/info':
        return (
          <Route
            path="/info"
            render={() => (<Login info />)}
          />
        );
      case '/error':
        return <Route path="/error" component={Error} />;
      case '/notfound':
        return <Route path="/notfound" component={NotFound} />;
      case '/access':
        return <Route path="/access" component={Access} />;
      default:
        return <App />;
    }
  }
}

AppWrapper.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(AppWrapper);
